export var EBindGoodWarnType;
(function (EBindGoodWarnType) {
    EBindGoodWarnType[EBindGoodWarnType["\u6B63\u5E38"] = 0] = "\u6B63\u5E38";
    EBindGoodWarnType[EBindGoodWarnType["\u786E\u8BA4\u6267\u884C"] = 1] = "\u786E\u8BA4\u6267\u884C";
})(EBindGoodWarnType || (EBindGoodWarnType = {}));
